import { instance } from "./AxiosInstance";

export const GetMasterData = (type) => instance.get(`superuser/getmastercode/${type}`);
